/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './DocumentRow.scss';
import BaseReactComponent from '../../../Util/BaseReactComponent';
import baseComponent from '../../../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import {SortableHandle} from 'react-sortable-hoc';

const DragHandle = SortableHandle(() => <div className="handle"></div>);

@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class DocumentRow extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        //this.setState({
        //    documents: this.props.documents
        //});
    }

    componentWillReceiveProps() {
        //this.setState({
        //    documents: nextProps.documents
        //});
    }

    deleteDocument(document) {
        this.props.deleteDocument(document);
    }

    render() {
        return (
            <li className="document-item">
                <div className="col-xs-1 handle-container">
                    <DragHandle />
                </div>
                <div className="col-xs-5">
                    <div className="document-name">{this.props.value.name}</div>
                    <div className="document-description">{this.props.value.description}</div>
                </div>
                <div className="col-xs-4">
                    <div><a href={this.props.value.url} target="_blank">{this.getIntlMessage('homepage.documents-panel.download')}</a></div>
                </div>
                <div className="col-xs-2">
                    <button onClick={this.deleteDocument.bind(this, this.props)} ><img src={require('../../../../public/trash.png')}/></button>
                </div>
            </li>
        )
    }

}

DocumentRow.propTypes = {
    changeDocumentPosition: React.PropTypes.func,
    deleteDocument: React.PropTypes.func
};

DocumentRow.defaultProps = {
    componentName: 'documents-list'
};

export default DocumentRow;



// WEBPACK FOOTER //
// /src/components/Document/List/Row/DocumentRow.js